(function () {
  if (window.gtjFavInit) return;
  window.gtjFavInit = true;

  var HEART_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.5-4.9-10-9.5C.4 8 2 4.5 5.5 4 7.7 3.7 9.6 4.8 12 7c2.4-2.2 4.3-3.3 6.5-3 3.5.5 5.1 4 3.5 7.5C19.5 16.1 12 21 12 21z"/></svg>';

  var cfg = window.GTJFavCfg || {};
  var cid = cfg.customerId ? String(cfg.customerId) : 'guest';
  var KEY = 'gtj_favs_' + cid;

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  // Merge guest favorites into the account list on login.
  if (cid !== 'guest') {
    try {
      var g = JSON.parse(localStorage.getItem('gtj_favs_guest'));
      if (Array.isArray(g) && g.length) {
        var cur = read();
        g.forEach(function (h) { if (cur.indexOf(h) === -1) cur.push(h); });
        write(cur);
        localStorage.removeItem('gtj_favs_guest');
      }
    } catch (e) {}
  }

  // ---- demand signal: mirror favorites into a hidden cart attribute ----
  var attrTimer = null;
  function syncCartAttr() {
    clearTimeout(attrTimer);
    attrTimer = setTimeout(function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _gtj_favorites: read().slice(0, 100).join(', ') } })
      }).catch(function () {});
    }, 1500);
  }

  // ---- toast (same visual family as the quick-add toast) ----
  function toastHost() {
    var host = document.getElementById('gtj-toast-host');
    if (!host) {
      host = document.createElement('div');
      host.id = 'gtj-toast-host';
      host.style.cssText = 'position:fixed;top:16px;right:16px;z-index:2147483000;display:flex;flex-direction:column;gap:10px;';
      document.body.appendChild(host);
    }
    return host;
  }
  function favToast(title, sub, linkText, href, onClick) {
    var t = document.createElement('div');
    t.style.cssText = 'min-width:230px;max-width:320px;background:#2d5016;color:#ffffff;border-radius:8px;box-shadow:0 6px 24px rgba(0,0,0,0.18);padding:12px 14px;font-size:14px;line-height:1.35;transform:translateX(120%);opacity:0;transition:transform .28s ease,opacity .28s ease;';
    var head = document.createElement('div');
    head.style.cssText = 'display:flex;align-items:center;gap:8px;font-weight:600;';
    var mark = document.createElement('span');
    mark.textContent = '♥';
    mark.style.cssText = 'display:inline-flex;width:18px;height:18px;border-radius:50%;background:#ffffff;color:#c0392b;align-items:center;justify-content:center;font-size:11px;flex:0 0 auto;';
    var lbl = document.createElement('span');
    lbl.textContent = title;
    head.appendChild(mark); head.appendChild(lbl); t.appendChild(head);
    if (sub) {
      var d = document.createElement('div');
      d.textContent = sub;
      d.style.cssText = 'margin-top:4px;opacity:.92;';
      t.appendChild(d);
    }
    if (linkText) {
      var a = document.createElement('a');
      a.textContent = linkText;
      a.href = href || '#';
      a.style.cssText = 'display:inline-block;margin-top:8px;color:#ffffff;text-decoration:underline;font-weight:600;cursor:pointer;';
      if (onClick) {
        a.addEventListener('click', function (e) { e.preventDefault(); onClick(); t.remove(); });
      }
      t.appendChild(a);
    }
    toastHost().appendChild(t);
    requestAnimationFrame(function () { t.style.transform = 'translateX(0)'; t.style.opacity = '1'; });
    setTimeout(function () {
      t.style.transform = 'translateX(120%)'; t.style.opacity = '0';
      setTimeout(function () { t.remove(); }, 300);
    }, 3200);
  }

  // ---- state -> UI ----
  function markHearts() {
    var list = read();
    var hearts = document.querySelectorAll('[data-gtj-fav]');
    for (var i = 0; i < hearts.length; i++) {
      var b = hearts[i];
      var on = list.indexOf(b.getAttribute('data-gtj-fav')) !== -1;
      b.classList.toggle('gtj-fav-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    var n = list.length;
    var counts = document.querySelectorAll('[data-gtj-fav-count]');
    for (var j = 0; j < counts.length; j++) {
      counts[j].textContent = n > 99 ? '99+' : String(n);
      if (n > 0) counts[j].removeAttribute('hidden'); else counts[j].setAttribute('hidden', '');
    }
  }
  function popBadge() {
    var counts = document.querySelectorAll('[data-gtj-fav-count]');
    for (var j = 0; j < counts.length; j++) {
      counts[j].classList.remove('gtj-fav-count--pop');
      void counts[j].offsetWidth;
      counts[j].classList.add('gtj-fav-count--pop');
    }
  }

  function addFav(h) {
    var l = read();
    if (l.indexOf(h) === -1) { l.push(h); write(l); }
    markHearts(); popBadge(); syncCartAttr();
  }
  function removeFav(h) {
    write(read().filter(function (x) { return x !== h; }));
    markHearts(); syncCartAttr();
  }
  function toggleFav(h) {
    if (read().indexOf(h) === -1) {
      addFav(h);
      var toasted = null;
      try { toasted = sessionStorage.getItem('gtjFavToasted'); } catch (e) {}
      if (!toasted) {
        try { sessionStorage.setItem('gtjFavToasted', '1'); } catch (e) {}
        favToast('Saved to your Favorites', null, 'View your list', '/pages/favorites', null);
      }
    } else {
      removeFav(h);
      favToast('Removed from Favorites', null, 'Undo', null, function () { addFav(h); renderPage(); });
      renderPage();
    }
  }

  // ---- cart helpers (mirrors gtj quick-add behavior) ----
  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      var sid = el.getAttribute('data-section-id');
      if (sid && ids.indexOf(sid) === -1) ids.push(sid);
    });
    return ids.join(',');
  }
  function announceCart(addData) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return {}; })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'gtj-favorites',
            data: {
              source: 'gtj-favorites',
              itemCount: typeof cart.item_count === 'number' ? cart.item_count : 1,
              sections: addData && addData.sections
            }
          }
        }));
      });
  }

  // ---- product page heart (next to the title) ----
  function productHandleFromPath() {
    if (location.pathname.indexOf('/products/') === -1) return null;
    var handle = location.pathname.split('/products/')[1];
    if (!handle) return null;
    handle = handle.split('/')[0].split('?')[0];
    return handle || null;
  }
  function makeInlineHeart(handle) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gtj-fav-heart gtj-fav-heart--inline';
    btn.setAttribute('data-gtj-fav', handle);
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', 'Save to your favorites');
    btn.setAttribute('title', 'Save to favorites');
    btn.innerHTML = HEART_SVG;
    return btn;
  }
  function ensureProductHeart() {
    var handle = productHandleFromPath();
    if (!handle) return;
    // Prefer a linked product title outside any product card
    var links = document.querySelectorAll('a[ref="productTitleLink"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.closest('product-card')) continue;
      if (a.parentElement && a.parentElement.querySelector('[data-gtj-fav]')) return;
      a.insertAdjacentElement('afterend', makeInlineHeart(handle));
      markHearts();
      return;
    }
    // Fallback: the main product H1
    var h1s = document.querySelectorAll('main h1, h1');
    for (var k = 0; k < h1s.length; k++) {
      var h1 = h1s[k];
      if (h1.closest('product-card')) continue;
      if (h1.querySelector('[data-gtj-fav]')) return;
      h1.appendChild(makeInlineHeart(handle));
      markHearts();
      return;
    }
  }

  // ---- favorites page ----
  var favCache = {};
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function pickVariant(p) {
    var i, t;
    for (i = 0; i < p.variants.length; i++) {
      t = (p.variants[i].title || '').toLowerCase();
      if (p.variants[i].available && (t.indexOf('assorted') !== -1 || t === 'asst' || t.indexOf('as pictured') !== -1)) return p.variants[i];
    }
    for (i = 0; i < p.variants.length; i++) { if (p.variants[i].available) return p.variants[i]; }
    return p.variants[0] || null;
  }
  function sized(img, w) {
    if (!img) return '';
    return img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function buildRow(handle, p) {
    var v = pickVariant(p);
    var row = document.createElement('div');
    row.className = 'gtj-favs__row';
    row.setAttribute('data-gtj-row', handle);
    if (v) row.setAttribute('data-variant-id', String(v.id));

    var imgLink = document.createElement('a');
    imgLink.href = '/products/' + handle;
    var img = document.createElement('img');
    img.src = sized(p.featured_image || (p.images && p.images[0]) || '', 180);
    img.alt = '';
    img.loading = 'lazy';
    imgLink.appendChild(img);
    row.appendChild(imgLink);

    var info = document.createElement('div');
    info.className = 'gtj-favs__info';
    var title = document.createElement('a');
    title.className = 'gtj-favs__title';
    title.href = '/products/' + handle;
    title.textContent = p.title;
    info.appendChild(title);
    var price = document.createElement('div');
    price.className = 'gtj-favs__price';
    var priceText = v ? money(v.price) : '';
    if (v && v.title && v.title !== 'Default Title') priceText += ' · ' + v.title;
    price.textContent = priceText;
    info.appendChild(price);
    row.appendChild(info);

    if (v && v.available) {
      var qty = document.createElement('div');
      qty.className = 'gtj-quick-add__qty';
      var dec = document.createElement('button');
      dec.type = 'button'; dec.className = 'gtj-quick-add__step'; dec.setAttribute('data-gtj-frow', 'dec'); dec.setAttribute('aria-label', 'Decrease quantity'); dec.innerHTML = '&minus;';
      var num = document.createElement('span');
      num.className = 'gtj-quick-add__qty-display'; num.setAttribute('data-gtj-frow-qty', ''); num.textContent = '1';
      var inc = document.createElement('button');
      inc.type = 'button'; inc.className = 'gtj-quick-add__step'; inc.setAttribute('data-gtj-frow', 'inc'); inc.setAttribute('aria-label', 'Increase quantity'); inc.textContent = '+';
      qty.appendChild(dec); qty.appendChild(num); qty.appendChild(inc);
      row.appendChild(qty);

      var add = document.createElement('button');
      add.type = 'button';
      add.className = 'gtj-quick-add__btn';
      add.setAttribute('data-gtj-frow', 'add');
      add.textContent = 'Add to cart';
      row.appendChild(add);
    } else {
      var oos = document.createElement('span');
      oos.className = 'gtj-favs__oos';
      oos.textContent = 'Out of stock';
      row.appendChild(oos);
    }

    var rm = document.createElement('button');
    rm.type = 'button';
    rm.className = 'gtj-favs__remove';
    rm.setAttribute('data-gtj-frow', 'remove');
    rm.setAttribute('data-handle', handle);
    rm.textContent = 'Remove';
    row.appendChild(rm);

    return row;
  }

  function renderPage() {
    var wrap = document.querySelector('[data-gtj-fav-list]');
    if (!wrap) return;
    var empty = document.querySelector('[data-gtj-fav-empty]');
    var addAll = document.querySelector('[data-gtj-add-all]');
    var list = read();
    if (!list.length) {
      wrap.innerHTML = '';
      if (empty) empty.removeAttribute('hidden');
      if (addAll) addAll.setAttribute('hidden', '');
      return;
    }
    if (empty) empty.setAttribute('hidden', '');
    Promise.all(list.map(function (h) {
      if (Object.prototype.hasOwnProperty.call(favCache, h)) return Promise.resolve(favCache[h]);
      return fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('nf'); return r.json(); })
        .then(function (p) { favCache[h] = p; return p; })
        .catch(function () { favCache[h] = null; return null; });
    })).then(function (prods) {
      var alive = [];
      prods.forEach(function (p, idx) { if (p) alive.push(list[idx]); });
      if (alive.length !== list.length) write(alive);
      wrap.innerHTML = '';
      var any = false;
      prods.forEach(function (p, idx) {
        if (!p) return;
        any = true;
        wrap.appendChild(buildRow(list[idx], p));
      });
      if (addAll) {
        if (any) addAll.removeAttribute('hidden'); else addAll.setAttribute('hidden', '');
      }
      if (!any && empty) empty.removeAttribute('hidden');
      markHearts();
    });
  }

  function setBusy(btn, busy, label) {
    if (busy) { btn.setAttribute('data-state', 'loading'); btn.textContent = 'Adding...'; }
    else { btn.removeAttribute('data-state'); btn.textContent = label; }
  }

  function addToCart(items, btn, successLabel, toastTitle, toastSub) {
    if (btn) setBusy(btn, true);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: items, sections: cartSectionIds(), sections_url: window.location.pathname })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function (data) {
      if (btn) { btn.setAttribute('data-state', 'added'); btn.textContent = 'Added!'; setTimeout(function () { setBusy(btn, false, successLabel); }, 1500); }
      favToast(toastTitle, toastSub, 'View cart', '/cart', null);
      return announceCart(data);
    }).catch(function () {
      if (btn) { btn.removeAttribute('data-state'); btn.textContent = 'Try again'; setTimeout(function () { setBusy(btn, false, successLabel); }, 1800); }
      favToast('Couldn’t add to cart', 'Check quantity minimums and try again.', null, null, null);
    });
  }

  // ---- clicks ----
  document.addEventListener('click', function (e) {
    var heart = e.target.closest('[data-gtj-fav]');
    if (heart) {
      e.preventDefault();
      e.stopPropagation();
      toggleFav(heart.getAttribute('data-gtj-fav'));
      return;
    }

    var frow = e.target.closest('[data-gtj-frow]');
    if (frow) {
      e.preventDefault();
      var row = frow.closest('[data-gtj-row]');
      var action = frow.getAttribute('data-gtj-frow');
      if (!row) return;
      var qtyEl = row.querySelector('[data-gtj-frow-qty]');
      var current = qtyEl ? (parseInt(qtyEl.textContent, 10) || 1) : 1;
      if (action === 'inc' && qtyEl) qtyEl.textContent = Math.min(current + 1, 99);
      else if (action === 'dec' && qtyEl) qtyEl.textContent = Math.max(current - 1, 1);
      else if (action === 'add') {
        var vid = row.getAttribute('data-variant-id');
        var titleEl = row.querySelector('.gtj-favs__title');
        addToCart([{ id: vid, quantity: current }], frow, 'Add to cart', 'Added to cart', titleEl ? titleEl.textContent : null);
      } else if (action === 'remove') {
        var h = frow.getAttribute('data-handle');
        removeFav(h);
        favToast('Removed from Favorites', null, 'Undo', null, function () { addFav(h); renderPage(); });
        renderPage();
      }
      return;
    }

    var addAllBtn = e.target.closest('[data-gtj-add-all]');
    if (addAllBtn) {
      e.preventDefault();
      var rows = document.querySelectorAll('[data-gtj-row][data-variant-id]');
      var items = [];
      rows.forEach(function (r) {
        if (!r.querySelector('[data-gtj-frow="add"]')) return;
        var q = r.querySelector('[data-gtj-frow-qty]');
        items.push({ id: r.getAttribute('data-variant-id'), quantity: q ? (parseInt(q.textContent, 10) || 1) : 1 });
      });
      if (!items.length) return;
      addToCart(items, null, null, items.length + (items.length === 1 ? ' design' : ' designs') + ' added to cart', null);
    }
  });

  // ---- init + keep hearts marked through Horizon re-renders ----
  var moT = null;
  function init() {
    markHearts();
    ensureProductHeart();
    renderPage();
    var mo = new MutationObserver(function () {
      clearTimeout(moT);
      moT = setTimeout(function () { markHearts(); ensureProductHeart(); }, 150);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
